import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { withStyles, CssBaseline } from '@material-ui/core';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import classnames from 'classnames';
// import Fullscreen from "react-full-screen";
import Header from '../Header';
import Sidebar from '../Sidebar';
import { withTranslation } from 'react-i18next';
import { checkByRole } from '../../utils/handleSidebar';

// pages
import Dashboard from '../../pages/dashboard';
import DevicesManager from '../../pages/devices/DevicesManager';
import DevicesPage from '../../pages/devices/DevicesPage';
import DeviceTypeManager from '../../pages/devicetype/DeviceTypeManager';
import DeviceTypePage from '../../pages/devicetype/DeviceTypePage';
import RoutersManager from '../../pages/routers/RoutersManager';
import RoutersPage from '../../pages/routers/RoutersPage';
import LocationsManager from '../../pages/locations/LocationsManager';
import LocationsPage from '../../pages/locations/LocationsPage';
import MapsManager from '../../pages/maps/MapsManager';
import MapsPage from '../../pages/maps/MapsPage';
import MapsPosition from '../../pages/maps/MapsPosition';
import GroupsManager from '../../pages/groups/GroupsManager';
import GroupsPage from '../../pages/groups/GroupsPage';
import AssignModules from '../../pages/groups/AssignModules';
import ModulesManager from '../../pages/modules/ModulesManager';
import ModulesPage from '../../pages/modules/ModulesPage';
import RoomsBedsManager from '../../pages/modules/ManageRoomBed/RoomsBedsManager';
import RoomsBedsPage from '../../pages/modules/ManageRoomBed/RoomsBedsPage';
import ManageDevicesPermission from '../../pages/modules/ManageDevicesPermission';
import UsersManager from '../../pages/users/UsersManager';
import UsersPage from '../../pages/users/UsersPage';
import ViewManager from '../../pages/users/ViewManager';
import PatientsManager from '../../pages/patients/PatientsManager';
import PatientsPage from '../../pages/patients/PatientsPage';
import Chart from '../../pages/charts/ChartsView';
import RolesManager from '../../pages/role/RoleManager';
import RolesPage from '../../pages/role/RolePage';
import LogActivity from '../../pages/logactivity/index';
import DevicePermission from '../../pages/devicepermission/DevicePermissionPage';
import AlertProfileManage from '../../pages/profiles/AlertProfileManage';
import AlertProfile from '../../pages/profiles/AlertProfile';
import AreasManager from '../../pages/areas/AreasManager';
import AreasPage from '../../pages/areas/AreasPage';
import SecurityGuard from '../../pages/dashboard/SecurityGuard';
// import Patient from '../../pages/dashboard/Patient';
import RouteTypeManager from '../../pages/routerType/RouterTypeManager';
import RouteTypePage from '../../pages/routerType/RoutersTypePage';
import SummaryPatientPage from '../../pages/summaryReport/SummaryPatientPage';
import AllPatients from '../../pages/allPatients/AllPatients';
import TenantManager from '../../pages/users/TenantManager';
import Wizard from '../../pages/wizard/Wizard';
import UsageSummary from '../../pages/usageSummary/UsageSummary';
import RouterUsageSummary from '../../pages/usageSummary/RouterUsageSummary';
import DeviceUsageSummary from '../../pages/usageSummary/DeviceUsageSummary';
import FixedButtonUsageSummary from '../../pages/usageSummary/FixedButtonUsageSummary';


export class Layout extends Component {
  render() {
    const { classes, isSidebarOpened } = this.props;
    const { activeFullScreen } = this.props.screen.toJS();
    const displayedMenus = checkByRole(localStorage.getItem('role'));
    // let styleFullScreen = activeFullScreen ? {overflowY: 'scroll', maxHeight: '600px'} : {overflowY: 'hidden'};
    let styleMargin =
      displayedMenus.length > 0 && !activeFullScreen ? { marginLeft: 44 } : { marginLeft: 2, marginRight: 2 };

    let dashboard = '';
    switch (localStorage.getItem('role')) {
      case 'Security Guard':
        dashboard = SecurityGuard;
        break;
      case 'Patient':
        dashboard = SummaryPatientPage;
        break;
      default:
        dashboard = Dashboard;
        break;
    }
    // let styleCustom = screen.openFullScreen ? {overflowY: 'scroll', maxHeight: '600px'} : {overflowY: 'hidden'}

    return (
      // <Fullscreen
      //   enabled={activeFullScreen}
      //   onChange={isFull => this.handleFullScreen(isFull)}
      // >
      <div className={classes.root}>
        <CssBaseline />
        <BrowserRouter>
          <React.Fragment>
            <Header />
            {displayedMenus.length > 0 && <Sidebar props={this.props} activeFullScreen={activeFullScreen} />}
            <div
              className={classnames(
                classes.content,
                { [classes.contentShift]: isSidebarOpened },
                classes.fullScreenCustom,
              )}
              style={styleMargin}
            >
              <div className={classes.fakeToolbar} /> {/*style={styleFullScreen}*/}
              <Switch>
                <Route exact path='/app/dashboard' component={dashboard} />
                <Route exact path='/app/allpatients' component={AllPatients} />
                <Route exact path='/app/usagesummary' component={UsageSummary} />
                <Route exact path='/app/usagesummary/router' component={RouterUsageSummary} />
                <Route exact path='/app/usagesummary/device' component={DeviceUsageSummary} />
                <Route exact path='/app/usagesummary/fixedbutton' component={FixedButtonUsageSummary} />
                <Route exact path='/app/wizard' component={Wizard} />
                <Route exact path='/app/devices' component={DevicesManager} />
                <Route exact path='/app/devices/create' component={DevicesPage} />
                <Route exact path='/app/devices/:id/edit' component={DevicesPage} />
                <Route exact path='/app/devices/:id/view' component={DevicesPage} />

                <Route exact path='/app/devicetype' component={DeviceTypeManager} />
                <Route exact path='/app/devicetype/create' component={DeviceTypePage} />
                <Route exact path='/app/devicetype/:id/edit' component={DeviceTypePage} />
                <Route exact path='/app/devicetype/:id/view' component={DeviceTypePage} />

                <Route exact path='/app/routers' component={RoutersManager} />
                <Route exact path='/app/routers/create' component={RoutersPage} />
                <Route exact path='/app/routers/:id/edit' component={RoutersPage} />
                <Route exact path='/app/routers/:id/view' component={RoutersPage} />

                <Route exact path='/app/routertype' component={RouteTypeManager} />
                <Route exact path='/app/routertype/create' component={RouteTypePage} />
                <Route exact path='/app/routertype/:id/edit' component={RouteTypePage} />
                <Route exact path='/app/routertype/:id/view' component={RouteTypePage} />

                <Route exact path='/app/locations' component={LocationsManager} />
                <Route exact path='/app/locations/create' component={LocationsPage} />
                <Route exact path='/app/locations/:id/edit' component={LocationsPage} />
                <Route exact path='/app/locations/:id/view' component={LocationsPage} />

                <Route exact path='/app/maps' component={MapsManager} />
                <Route exact path='/app/maps/create' component={MapsPage} />
                <Route exact path='/app/maps/:id/edit' component={MapsPage} />
                <Route exact path='/app/maps/:id/view' component={MapsPage} />
                <Route exact path='/app/maps/:id/manage' component={MapsPosition} />

                <Route exact path='/app/groups' component={GroupsManager} />
                <Route exact path='/app/groups/create' component={GroupsPage} />
                <Route exact path='/app/groups/:id/edit' component={GroupsPage} />
                <Route exact path='/app/groups/:id/view' component={GroupsPage} />
                <Route exact path='/app/groups/:id/assign' component={AssignModules} />

                <Route exact path='/app/modules' component={ModulesManager} />
                <Route exact path='/app/modules/create' component={ModulesPage} />
                <Route exact path='/app/modules/:id/edit' component={ModulesPage} />
                <Route exact path='/app/modules/:id/view' component={ModulesPage} />

                <Route exact path='/app/areas' component={AreasManager} />
                <Route exact path='/app/areas/create' component={AreasPage} />
                <Route exact path='/app/areas/:id/edit' component={AreasPage} />
                <Route exact path='/app/areas/:id/view' component={AreasPage} />

                <Route exact path='/app/modules/:id/manage' component={RoomsBedsManager} />
                <Route exact path='/app/modules/:id/manage/create' component={RoomsBedsPage} />
                <Route exact path='/app/modules/:id/bed/:idbed/edit' component={RoomsBedsPage} />
                <Route exact path='/app/modules/:id/bed/:idbed/view' component={RoomsBedsPage} />
                <Route exact path='/app/modules/:id/manage/device' component={ManageDevicesPermission} />

                <Route exact path='/app/users' component={UsersManager} />
                <Route exact path='/app/users/create' component={UsersPage} />
                <Route exact path='/app/users/:id/edit' component={UsersPage} />
                <Route exact path='/app/users/:id/view' component={UsersPage} />
                <Route exact path='/app/users/:id/manage' component={ViewManager} />
                <Route exact path='/app/users/:id/tenant' component={TenantManager} />

                <Route exact path='/app/roles' component={RolesManager} />
                <Route exact path='/app/roles/create' component={RolesPage} />
                <Route exact path='/app/roles/:id/edit' component={RolesPage} />
                <Route exact path='/app/roles/:id/view' component={RolesPage} />

                <Route exact path='/app/patients' component={PatientsManager} />
                <Route exact path='/app/patients/create' component={PatientsPage} />
                <Route exact path='/app/patients/:id/edit' component={PatientsPage} />
                <Route exact path='/app/patients/:id/view' component={PatientsPage} />

                <Route exact path='/app/chart' component={Chart} />
                <Route exact path='/app/log' component={LogActivity} />

                <Route exact path='/app/devicepermission' component={DevicePermission} />

                <Route exact path='/app/alertprofile' component={AlertProfileManage} />
                <Route exact path='/app/alertprofile/create' component={AlertProfile} />
                <Route exact path='/app/alertprofile/:id/edit' component={AlertProfile} />
                <Route exact path='/app/alertprofile/:id/view' component={AlertProfile} />
              </Switch>
            </div>
          </React.Fragment>
        </BrowserRouter>
      </div>
      // </Fullscreen>
    );
  }
}
const styles = (theme) => ({
  root: {
    display: 'flex',
    maxWidth: '100vw',
    overflowX: 'unset',
    backgroundColor: theme.palette.background.default,
  },
  content: {
    flexGrow: 1,
    // padding: theme.spacing.unit * 3,
    width: `calc(100vw - 240px)`,
    minHeight: '100vh',
    overflow: 'hidden',
  },
  contentShift: {
    width: `calc(100vw - ${240 + theme.spacing.unit * 6}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  fakeToolbar: {
    minHeight: '54px',
    backgroundColor: 'white',
    // ...theme.mixins.toolbar
  },
  fullScreenCustom: {
    '@media (min-height: 900px)': {
      // overflowY: 'scroll',
      // maxHeight: '600px',
    },
  },
});

export const page = inject('screen')(observer(Layout));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
